module.exports = __webpack_public_path__ + "img/closed_switch.8686f973.jpeg";